import * as R from 'ramda'

import buildSkuName from '../../modules/buildSkuName.js'

export default {
  '': [
    {
      src: 'buyerRef',
      fill: buyerRef => {
        const buyer = R.pick(
          ['key', 'contact', 'phone', 'fax', 'email', 'address'],
          buyerRef,
        )

        return { buyer }
      },
    },
  ],
  'items.0': {
    src: 'skuRef',
    fill: sku => ({
      sku,
      name: buildSkuName(sku),
    }),
  },
}
